import React, { FC, ReactNode } from 'react';
import { DatePicker, FormItemProps, DatePickerProps } from 'antd';
import { JInputWrapper } from '../JInputWrapper';
import moment, { Moment } from "moment";
import { disabledDate as _disabledDate } from '../../JFormCompositor/utils';
import { pickerLocale } from '../../lib/utils/picker-locale';


export type JDatePickerProps = {
    /**
     * Action to update external module
     * @param value
     */
    onChange?: (value: any) => void;
    /**
     * label
     */
    label?: ReactNode;

    /**
     * name
     */
    name?: string | number | (string | number)[];
    /**
     * Date format
     */
    format?: string;

    /**
     * Placeholder
     */
    placeholder?: string;

    /**
     * disabled
     */
    disabled?: boolean;

    /**
     * showTime
     */
    showTime?: boolean;

    /**
     * ant design Form.Item props
     * https://ant.design/components/form/#API
     */
    itemProps?: FormItemProps;

    /**
     * Default Value
     */
    defaultValue?: any;

    /**
     * Value
     */
    value?: string;

    /**
     * Value
     */
    disabledDate?: (current: moment.Moment) => boolean;

    /**
     * ant design Input props
     * https://ant.design/components/date-picker/#API
     */
    datePickerProps?: DatePickerProps;

    /**
     * Disabled min picker date
     */
    minDate?: Date,

    /**
     * Disabled max picker date
     */
    maxDate?: Date,

    /**
     * Error message
     */
    errorMessage?: string,
};

export const JDatePicker: FC<JDatePickerProps> = ({
    label,
    name,
    showTime = false,
    format = (showTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'),
    disabled,
    onChange,
    itemProps,
    defaultValue,
    placeholder,
    disabledDate,
    errorMessage,
    ...otherProps
}) => {
    const defaultValueTMP = defaultValue ? moment(defaultValue) : undefined;

    const localDisableDate = (m: Moment) => {
        if (disabledDate) return disabledDate(m)
        return _disabledDate(m, otherProps.minDate, otherProps.maxDate)
    }

    const renderDatePicker = () => (
        <DatePicker
            showTime={showTime && { format: 'HH:mm' }}
            disabled={disabled}
            defaultValue={defaultValueTMP}
            format={format}
            locale={pickerLocale}
            placeholder={placeholder}
            onChange={(e) => {
                const formatedDate = moment(moment(e).format("YYYY-MM-DDTHH:mm:ss.SSSSZ").replace('T00', 'T04')) // Temporary hack because calendar is on US timezone, and manual entry on IT timezone
                const value = showTime ? e : formatedDate
                return onChange ? onChange(value) : ''
            }}
            disabledDate={localDisableDate}
            aria-describedby={errorMessage}
        />
    )

    return (
        <>
            {
                label
                    ? <JInputWrapper label={label} name={name} {...itemProps}>
                        {renderDatePicker()}
                    </JInputWrapper>
                    : renderDatePicker()
            }
        </>
    );
};
